import React, { useId } from 'react';

interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const Tooltip = ({ content, children, className = '' }: TooltipProps) => {
  const tooltipId = useId();

  return (
    <span className={`group relative inline-flex ${className}`}>
      <span aria-describedby={tooltipId} tabIndex={0} className="inline-flex focus:outline-none">
        {children}
      </span>
      <span
        id={tooltipId}
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-30 mb-2 hidden w-max max-w-xs -translate-x-1/2 rounded-md bg-gray-900 px-2 py-1.5 text-xs font-normal leading-snug text-white shadow-lg group-hover:block group-focus-within:block"
      >
        {content}
        <span className="absolute left-1/2 top-full h-2 w-2 -translate-x-1/2 -translate-y-1 rotate-45 bg-gray-900" />
      </span>
    </span>
  );
};

export default Tooltip;
